<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <el-form slot="content" :ref="formName" :model="domainInfo" :rules="rules" label-position="top">
      <div class="mr-b20">
        <el-form-item label="도메인명" prop="domainName">
          <el-input v-model="domainInfo.domainName" placeholder="입력해 주십시오." />
        </el-form-item>
      </div>
      <!-- <el-form-item label="트랜잭션 보관 주기" prop="txStoreDay">
        <el-input-number v-model="domainInfo.txStoreDay" :min="1" /> 일
      </el-form-item> -->
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="!disabledSaveBtn" @click="saveDomain">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { clone, isEqual, isEmpty } from 'lodash';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';

const DEFAULT_DOMAIN = {
  domainName: '',
  txStoreDay: 7,
};
export default {
  name: 'WDomainSettingPopup',
  props: {
    popupType: {
      type: String,
    },
  },
  data() {
    return {
      formName: 'domainSettingForm',
      domainInfo: clone(DEFAULT_DOMAIN),
      originalDomainInfo: clone(DEFAULT_DOMAIN),
      rules: {
        domainName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
    };
  },
  computed: {
    popupTitle() {
      return this.popupType === 'ADD' ? '도메인 추가' : '도메인 변경';
    },
    disabledSaveBtn() {
      return !isEqual(this.originalDomainInfo, this.domainInfo);
    },
  },
  methods: {
    closePopup() {
      this.domainInfo = clone(DEFAULT_DOMAIN);
      this.originalDomainInfo = clone(DEFAULT_DOMAIN);
      this.$refs.slidingPopup.visible = false;
    },
    open(updateData) {
      this.$refs.slidingPopup.visible = true;
      if (!isEmpty(updateData)) {
        this.domainInfo = clone(updateData);
        this.originalDomainInfo = clone(updateData);
      }
    },
    /**
     * 도메인을 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    saveDomain() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const url = this.popupType === 'ADD' ? 'insertDomain' : 'updateDomain';
          ApmSettingAPI[url](this.domainInfo).then((response) => {
            if (response.data.success) {
              this.$emit('reloadData');
              this.closePopup();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action[this.popupType], '도메인', response.data.success));
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주십시오.'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/DomainSettingPopup.vue